import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useAuth } from '../hooks/common/useAuth';
import FullscreenLoader from '../components/base/FullscreenLoader';
import NotAuthorized from '../pages/errors/NotAuthorized';

import { PATH_PERMISSIONS } from '../constants/service/common/pathPermissions';
import { AuthUserPermission } from '../types/common/PermissionType';

interface IAuthorizedRouteProps {
  children: React.ReactNode;
  level?: number;
}

const AuthorizedAdminRoute: React.FC<IAuthorizedRouteProps> = ({ children, level }) => {
  const { userLoading, user, userPermissions } = useAuth();
  const location = useLocation();
  const params = useParams<{ id?: string }>();

  if (userLoading) {
    return <FullscreenLoader className="lower-zIndex" visible={userLoading} />;
  }

  // id를 포함한 path는 제외 후 검증하기 위해 아래 정규식을 추가함
  const routerPermissions = PATH_PERMISSIONS.find((p) => {
    const pattern = p.path.replace(/:\w+/g, '.+');
    const regex = new RegExp(`^${pattern}$`);
    return regex.test(location.pathname);
  });

  let isAuthorized = routerPermissions
    ? user &&
      userPermissions &&
      routerPermissions.permissions.every((p) => {
        const permissionValue = (userPermissions as AuthUserPermission)[routerPermissions.resource]?.[p];
        return !!permissionValue;
      })
    : false;

  if (level !== undefined) {
    isAuthorized = user && (user.level === level || Number(params.id) === user.id);
  }

  return isAuthorized ? <>{children}</> : <NotAuthorized />;
};

export default AuthorizedAdminRoute;
